import React from "react";

import withStyles from '@mui/styles/withStyles';
import classnames from "classnames";

import { capitalizeFirstLetterAllWorlds } from "../../../../../util/capitalizeFirstLetter";
import { MarineEventsStatus } from "../../../../../util/enums";

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  classes?: any;
  className?: string;
};

const styles = () =>
  ({
    customBadge: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
        props?.backgroundColor,
      padding: "8px 12px",
      height: "32px",
      borderRadius: "100px",
      whiteSpace: "nowrap",
      width: "fit-content",
    },
    textValue: {
      color: (props: { textColor?: string }) => props?.textColor,
      fontFamily: "Manrope",
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "16px",
    },
  } as const);

const SimpleBadge = (props: Props) => {
  const { classes, value, className, dataCy } = props;

  return (
    <div className={classnames(classes.customBadge, className)}>
      <span className={classes.textValue} data-cy={dataCy}>
        {value}
      </span>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

const EventBadgeStatus = (props: Props) => {
  const { value, className, dataCy } = props;

  const renderBadge = (
    backgroundColor: string,
    textColor: string,
    value?: string,
    formatWord = true
  ) => {
    if (value) {
      const formatted = formatWord ? capitalizeFirstLetterAllWorlds(value) : value;

      return (
        <StyledBadge
          dataCy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={formatted}
          className={className}
        />
      );
    }

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case MarineEventsStatus.COMPLETED.toLowerCase():
      return renderBadge("#ECFDF3", "#039855", value);
    case MarineEventsStatus.PLANNED.toLowerCase():
      return renderBadge("#F2F4F7", "#475467", value);
    case MarineEventsStatus.IN_PROGRESS.toLocaleLowerCase():
      return renderBadge("#FFFAEB", "#DC6803", value);
    default:
      return renderBadge("#F4F3FF", "#6938EF", value);
  }
};

export default EventBadgeStatus;
